/// <reference path="../../../tools/typings/angularjs/angular.d.ts"/>
/// <reference path="../notes/notes.ts"/>

// NOT YET IN USE
//
namespace DealerwareWebServices {
    "use strict";

    export interface IDealerwareAddressFactory {
        load (id : number)      : ng.IPromise<{}>;
        getInstance()           : IDealerwareAddress;
    }

    export interface IDealerwareAddress {
        id                      : number;
        line1                   : string;
        line2                   : string;
        city                    : string;
        state                   : string;
        zip                     : string;
        latitude                : string;
        longitude               : string;

        clear ()                : void;
        load (id?: number)      : ng.IPromise<{}>;
        save (id?: number)      : ng.IPromise<{}>;
        add ()                  : ng.IPromise<{}>;
        update (id?: number)    : ng.IPromise<{}>;
        delete (id?: number)    : ng.IPromise<{}>;
    }
}
